export function normalizeNumericInput(raw: string): string {
  const trimmed = raw.replace(/[^\d.-]/g, '');
  const negative = trimmed.startsWith('-');
  const unsigned = trimmed.replace(/-/g, '');
  const [whole = '', ...rest] = unsigned.split('.');
  const decimal = rest.length > 0 ? `.${rest.join('')}` : '';

  return `${negative ? '-' : ''}${whole}${decimal}`;
}

export function normalizeNumericValue(value: string | number | boolean | null | undefined): string {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : '';
  }

  if (typeof value !== 'string') return '';

  return value.replace(/[$,\s]/g, '').trim();
}

export function isValidNumericFieldValue(value: string | number | boolean | null | undefined): boolean {
  const normalized = normalizeNumericValue(value);
  if (!normalized) return false;

  return Number.isFinite(Number(normalized));
}
